import { render, staticRenderFns } from "./AuthForgotPasswordUsername.vue?vue&type=template&id=7684ddb8"
import script from "./AuthForgotPasswordUsername.vue?vue&type=script&lang=js"
export * from "./AuthForgotPasswordUsername.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports